import request from '@/apis/request'
const resource = 'chats' 

export default {
  get: (params) => {
    return request.get(`${resource}`,{params})
  },

  send: (data) => {
    return request.post(`${resource}`,data)
  },  
}